import { Component, EventEmitter, Output } from '@angular/core';
import { BusinessService } from '../business.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { SessionStorageService } from '@app/core/local-storage/local-storage.service';
import { InfoService } from '@app/core/info/info.service';
import { IBusinessGroup, IBusinessUser, IGroupRequest, IService } from '../business-models';

@Component({
  selector: 'cloud-business-group',
  templateUrl: './business-group.component.html',
  styleUrls: ['./business-group.component.scss']
})
export class BusinessGroupComponent {

  title: string = '';
  editedGroup: IBusinessGroup;
  isEdit: boolean = false;
  groupForm: FormGroup;
  asyncInputValue: IBusinessUser[];
  businessAccountId: string;
  loaded: boolean = false;
  companyServices: IService[];


  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private businessService: BusinessService,
    private translateService: TranslateService,
    private sessionStorageService: SessionStorageService,
    public info: InfoService,
  ) { }


  ngOnInit() {
    this.title = this.translateService.instant('businessTexts.addGroup')
    if (this.data.group) {
      this.title = this.translateService.instant('businessTexts.editGroup');
      this.editedGroup = this.data.group;
      this.isEdit = true;
    }
    this.companyServices = this.data.services;

    this.initForm();
    this.getUsers();
  }

  getUsers() {
    this.businessAccountId = this.sessionStorageService.getItem("businessAccountId");
    this.businessService.getUsers(this.businessAccountId).subscribe(res => {
      this.asyncInputValue = res.data;
      this.loaded = true;
      if (this.isEdit) {
        this.setInitialUsers();
      }
    });
  }

  initForm() {
    this.groupForm = this.formBuilder.group({
      name: new FormControl({ value: this.isEdit ? this.editedGroup.name : '', disabled: false }, Validators.required),
      services: new FormArray([], Validators.required),
      users: new FormArray([])
    });
    if (this.isEdit) {
      this.setInitialServices();
    }
  }

  setInitialServices() {
    const formArray: FormArray = this.groupForm.get('services') as FormArray;
    this.editedGroup.serviceTypes.forEach(serviceType => {
      formArray.push(new FormControl(this.companyServices.find(s => s.serviceType == serviceType)));
    })
  }

  setInitialUsers() {
    const formArray: FormArray = this.groupForm.get('users') as FormArray;
    const groupUsers = this.asyncInputValue.filter(p => p.groups.find(g => g.id === this.editedGroup.id));
    groupUsers.forEach(user => {
      formArray.push(new FormControl(user));
    })
  }

  isChecked(service) {
    const formArray: FormArray = this.groupForm.get('services') as FormArray;
    const found = formArray.value.find((obj) => {
      return obj.serviceType === service.serviceType;
    });
    return found ? true : false;
  }

  onCheckChange(event, service) {
    const formArray: FormArray = this.groupForm.get('services') as FormArray;
    if (event.checked) {
      formArray.push(new FormControl(service));
    }
    else {
      let i: number = 0;
      formArray.controls.forEach((ctrl: FormControl) => {
        if (ctrl.value.serviceType == service.serviceType) {
          formArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  closeDialog(value) {
    this.close.emit(value);
  }

  onSave() {
    let request = {} as IGroupRequest;
    request.companyCmrId = this.businessAccountId;
    request.groupName = this.groupForm.value.name;
    request.services = this.groupForm.value.services.map(s => s.serviceType);
    request.employeeCustomerUserIds = this.groupForm.value.users.map(u => u.customerUserId);
    if (this.isEdit) {
      request.groupId = this.editedGroup.id;
      this.businessService.updateGroup(request).subscribe(res => {
        if (res.status == 200) {
          this.info.success(this.translateService.instant('businessTexts.successEditGroup'));
          this.businessService.updateUserTable.next(true);
          this.businessService.updateGroupTable.next(true);
          this.businessService.updateNavBar.next(true);
        } else {
          this.info.error(this.translateService.instant('businessTexts.errorEditGroup'));
        }
      })
      this.closeDialog(true);
    } else {
      if (this.groupForm.valid) {
        this.businessService.addGroup(request).subscribe(res => {
          if (res.status == 200) {
            this.info.success(this.translateService.instant('businessTexts.successAddGroup'));
            this.businessService.updateUserTable.next(true);
            this.businessService.updateGroupTable.next(true);
            this.businessService.updateNavBar.next(true);
          } else {
            this.info.error(this.translateService.instant('businessTexts.errorAddGroup'));
          }
        })
        this.closeDialog(true);
      } else {
        this.displayErrorMessage(this.groupForm);
      }
    }
  }

  displayErrorMessage(form) {
    if(!form.controls.services.valid) {
       this.info.error(this.translateService.instant('businessTexts.noService'));
    } else {
        this.info.error(this.translateService.instant('businessTexts.noUser'));
    }
  }

  getButtonLabel() {
    return this.isEdit ? this.translateService.instant('businessTexts.edit') : this.translateService.instant('businessTexts.add');
  }

  getServiceName(service) {
    return this.lang == 'bg' ? service.nameBg : service.nameEn;
  }

  get lang() {
    return this.translateService.currentLang;
  }

  compareServiceObjects(o1: any, o2: any) {
    return o1.serviceType == o2.serviceType;
  }

  onCheckFunction(event) {
    const formArray: FormArray = this.groupForm.get('users') as FormArray;
    if (event.checked) {
      formArray.push(new FormControl(event.element));
    } else {
      let i: number = 0;
      formArray.controls.forEach((ctrl: FormControl) => {
        if (ctrl.value.customerUserId == event.element.customerUserId) {
          formArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

}
